import React from "react";
import { MimaButton, MimaText, Modal } from "../../components";

const DeleteCharge = ({ closeModal, data, handleDelete, loading }) => {
    return (
        <Modal closeModal={closeModal} goBack={closeModal}>
            <MimaText variant="subtitleBold" align="center" mb={3}>
                Delete Charge
            </MimaText>

            <MimaText mb={2} align="center">
                Are you sure you want to delete <br></br><span style={{ fontWeight: '700', color: 'var(--color-primary)' }}>{`${data.name} CHARGE?`}</span>
            </MimaText>

            <div className='modal__beside'>
                <MimaButton
                    title={'Yes'}
                    width={18}
                    onClick={() => handleDelete(data._id)}
                    loading={loading}
                />

                <MimaButton
                    title={'Cancel'}
                    width={18}
                    buttonColor={'grey'}
                    onClick={() => closeModal()}
                />
            </div>
        </Modal>
    )
}
export default DeleteCharge;